import { IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsImage } from "./image";

export class FsImage360 extends FsImage {
    type: IFsFileType.Image360 = IFsFileType.Image360

    constructor(fileId: string, name: string) {
        super(fileId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/img.hq`
        this.imageUrl = url.toString()
    }
}
